import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css";

import App from './App';

import { createTheme } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

const loc = window.location.pathname.split("/");
var lang = (loc.length > 0) ? loc[1] : "fa";
if(loc[1] !== "en" && loc[1] !== "fa"){
  lang = "fa"
}
const theme = createTheme({
  direction: (lang === "fa" ? "rtl" : "ltr"),
});

// Create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [
    prefixer,
    rtlPlugin
  ],
});
const cacheLtr = createCache({
  key: 'muiltr',
  stylisPlugins: [
    prefixer,
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      <CacheProvider value={(lang === "fa" ? cacheRtl : cacheLtr)} >
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </CacheProvider>
  </React.StrictMode>
);
if (
  'serviceWorker' in navigator 
  && process.env.NODE_ENV !== "development"
) {
  console.log(process.env.NODE_ENV)
  navigator.serviceWorker.register(
    '/service-worker.js?hash='+ parseInt(Date.now()/1000)
  )
}